<template>
    <v-dialog 
        v-model="dialog" 
        width="600" 
        @click:outside="closeModal"
    >
        <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar color="secondary" flat class="white--text">
                <v-toolbar-title class="font-weight-bold"> Contact Us</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="py-10">
                <div
                    class="text-center" 
                >
                    <v-img
                        lazy-src="/icons/email.png"
                        max-height="35"
                        max-width="35"
                        src="/icons/email.png"
                        style="margin: auto;"
                    ></v-img>
                    <p class="mt-4 black--text font-weight-bold" style="width:50%; margin:auto;">Please contact us directly at help@dimitra.io with your question or feedback</p>
                    <div class="hr-tag mt-5" style="width:60%; margin:auto;">
                        <hr/>
                        <h4  class="black--text px-2"> OR </h4>
                        <hr>
                    </div>

                    <v-btn :disabled="currentRouteName=='CreateEnquiry'" large color="primary" depressed class="my-5" @click="() => {$router.push({name: 'CreateEnquiry'});closeModal();}">CREATE A NEW ENQUIRY</v-btn>
                    <!-- <div class="hr-tag mb-5" style="width:50%; margin:auto;">
                        <hr/>
                        <h4  class="black--text px-2"> OR </h4>
                        <hr>
                    </div>
                    <v-img
                        lazy-src="/icons/phones.png"
                        max-height="35"
                        max-width="35"
                        src="/icons/phones.png"
                        style="margin: auto;"
                    ></v-img>
                    <div class="mt-4 font-weight-bold black--text">+628192556729</div>
                    <p class="mt-2 black--text ">Please feel free to call us via phone</p> -->
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
  
<script>
    import loadingMixin from "@/mixins/LoadingMixin";
    import generalMixin from "@/mixins/GeneralMixin";

  
    export default {
        computed: {
            dialog() {
                return this.dialogU;
            },
            currentRouteName() {
                return this.$route.name;
            }
        },
        data() {
            return {

            };
        },
        methods: {
            closeModal() {
                this.$emit("closeContactUs");
            },
        },
        props: {
            dialogU: {
                type: Boolean,
                required: true,
            },
        },
        mixins: [
            loadingMixin, 
            generalMixin
        ],
    };
  </script>
  
  <style lang="scss">
        .hr-tag {
            display: flex;
            flex-direction: row;
        }
          
        .hr-tag:before,
        .hr-tag:after {
            content: "";
            flex: 1 1;
            border-bottom: 1px solid #D9D9D9;
            margin: auto;
            padding: 0px;
            width: 50% !important;
        }
  </style>
  